import { useState } from "react";
import Container from "../Components/Container";
import Row from "../Components/Row";
import {
  BgLogo,
  ContentWrapper,
  Page,
  PlayerWrapper,
  SearchInput,
  Thumb,
  VideoCard,
  VideoTitle,
} from "./components";
import Button from "../Components/Button";
import LogoTransparent from "../assets/images/logo-transparent.png";

const videos = [
  {
    title:
      "Como Criar um Atendente Automático no WhatsApp com IA em 3 Minutos (Grátis e Sem Complicação)",
    videoId: "R5Yhk1jW4ww",
  },
  {
    title:
      "Como funciona a Base de Conhecimento do Alfred",
    videoId: "iOihdE6Vphk",
  },
];

const VideosPage = () => {
  const [selectedVideo, setSelectedVideo] = useState<{
    title: string;
    videoId: string;
  } | null>(null);
  const [search, setSearch] = useState("");

  const filteredVideos = videos.filter((v: any) =>
    v.title.toLowerCase().includes(search.toLowerCase())
  );

  const isMobile = window.innerWidth <= 768;

  return (
    <Page>
      <BgLogo src={LogoTransparent} alt="logo" />
      <Container style={{ paddingTop: isMobile ? "100px" : "200px" }}>
        {!selectedVideo && (
          <>
            <ContentWrapper>
              <SearchInput
                placeholder="Pesquisar vídeos..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </ContentWrapper>

            <Row
              xs="1fr"
              sm="1fr 1fr"
              md="1fr 1fr 1fr"
              lg="1fr 1fr 1fr 1fr"
              gap="24px"
              style={{ marginTop: "40px" }}
            >
              {filteredVideos.map((video) => (
                <VideoCard
                  key={video.videoId}
                  onClick={() => setSelectedVideo(video)}
                >
                  <Thumb>
                    <iframe
                      src={`https://www.youtube.com/embed/${video.videoId}`}
                      title={video.title}
                    />
                  </Thumb>
                  <VideoTitle>{video.title}</VideoTitle>
                </VideoCard>
              ))}
            </Row>
          </>
        )}

        {selectedVideo && (
          <>
            <Button
              onClick={() => setSelectedVideo(null)}
              style={{ width: "100px", color: "#000000", justifyContent: 'space-between' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="15"
                height="15"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 105.4-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
              </svg>
              Voltar
            </Button>

            <div style={{ marginTop: "30px" }}>
              <PlayerWrapper>
                <iframe
                  src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1`}
                  title={selectedVideo.title}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              </PlayerWrapper>
            </div>
          </>
        )}
      </Container>
    </Page>
  );
};

export default VideosPage;
